import { getNearbySToreApi } from 'app/pages/product-screen-new/api';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

function MoreShopsAround() {
  const [moreShops, setMoreShops] = useState(null);
  const { selectedAddress } = useSelector((state) => state.main);
  const latLng = selectedAddress
    ? `${selectedAddress.location.lat},${selectedAddress.location.lng}`
    : '19.1207983,72.8782323';

  useEffect(() => {
    getNearbySToreApi('get', null, latLng).then((res) => {
      setMoreShops(res.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {moreShops
        && (
          <>
            {(moreShops.city.length > 0
            || moreShops.localities.length > 0
            || moreShops.storeCategories.length > 0
            )
            && (
            <Container
              className="bg-light pt-6"
            >
              <Row>
                <Col
                  xs={24}
                  className="bg-light text-gray-light pt-6 text-center"
                >
                  <h2>Discover Shops Around You</h2>
                </Col>
              </Row>

              <Row>
                <Col
                  xs={24}
                  className="bg-light text-gray-light pt-3 text-center d-flex flex-wrap justify-content-center"
                >
                  {moreShops.city.map((item) => (
                    <div className="blogLinks" key={item.name}>
                      <a href={item.link} rel="noopener noreferrer">
                        Shops in
                        {' '}
                        {item.name}
                      </a>
                    </div>
                  ))}
                  {moreShops.storeCategories.map((item) => (
                    <div className="blogLinks" key={item.name}>
                      <a href={item.link} rel="noopener noreferrer">
                        {item.name}
                      </a>
                    </div>
                  ))}
                  {moreShops.localities.map((item) => (
                    <div className="blogLinks" key={item.name}>
                      <a href={item.link} rel="noopener noreferrer">
                        Stores in
                        {' '}
                        {item.name}
                      </a>
                    </div>
                  ))}
                </Col>
              </Row>
            </Container>
            )}
          </>
        )}
    </div>
  );
}

export default MoreShopsAround;
